import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import PackagingDispatchCreateView from 'src/sections/packaging-dispatch/view/packaging-dispatch-create-view';

export default function PackagingDispatchCreatePage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Create a new packaging dispatch</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.CREATE_PACKAGING_DISPATCH,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <PackagingDispatchCreateView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
